<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
        <div class="vx-row">
          <div class="vx-col w-7/12">
            <vx-card class="mb-base" title="Datos camarero">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <h4 class="text-uppercase">{{ $t('user.UserInfo') }}</h4>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Nombre" rules="required|minLength:5" v-slot="{ errors }">
                      <vs-input label-placeholder="Nombre" v-model="name" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Apellidos" rules="required" v-slot="{ errors }">
                      <vs-input label-placeholder="Apellidos" v-model="surname" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Correo electrónico" rules="required|email" v-slot="{ errors }">
                      <vs-input label-placeholder="Correo electrónico" v-model="email" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Teléfono" rules="required" v-slot="{ errors }">
                      <vs-input label-placeholder="Teléfono" v-model="phone" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3">
                    <ValidationProvider name="Puesto" rules="required" v-slot="{ errors }">
                      <vs-input label-placeholder="Puesto" v-model="job" required="true" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3" v-if="itemsRestaurants">
                    <ValidationProvider name="Restaurantes" rules="required" v-slot="{ errors }">
                      <vs-select
                        label="Restaurantes"
                        v-model="restaurants"
                        multiple
                        class="selectRestaurants w-full"
                        @change="restaurantsChanged"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.id"
                          :text="item.name"
                          v-for="(item, index) in itemsRestaurants"
                        />
                      </vs-select>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vx-input-group class="mb-5 mt-3" v-if="itemsTables">
                    <vs-select label="Mesas" v-model="tables" multiple class="selectTables w-full">
                      <vs-select-group
                        :title="item.title"
                        v-if="item.group"
                        class="mb-3"
                        :key="index"
                        v-for="(item, index) in itemsTables"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item, index) in item.group"
                        />
                      </vs-select-group>
                    </vs-select>
                    <vs-checkbox
                      :key="index"
                      v-for="(item, index) in itemsTables"
                      v-model="checkRestaurants[index]"
                      @change="selectRestaurant(index)"
                      class="my-2"
                      >{{ $t('SeleccionarTodas') }} - {{ item.title }}</vs-checkbox
                    >
                  </vx-input-group>
                </div>
                <div class="vx-col w-full mt-4">
                  <p class="text-uppercase"><strong>{{ $t('SecurityAccount') }}</strong></p>
                </div>
                <div class="vx-col w-full">
                  <div class="vx-col w-full text-right mb-3">
                    <vs-button color="primary" type="border" @click="generateRandomPassword()" size="small">
                      {{ $t('GeneratePassword') }}
                    </vs-button>
                  </div>
                  <ValidationProvider name="Contraseña" rules="required|min:8" v-slot="{ errors }">
                    <vx-input-group class="mb-2 mt-3">
                      <vs-input
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        placeholder="Contraseña"
                        hint="At least 8 characters"
                        counter
                        outlined
                        v-model="password"
                        class="w-full"
                      ></vs-input>
                      <template slot="append">
                        <div class="append-text bg-primary" @click="show1 = !show1">
                          <span>
                            <feather-icon
                              :icon="show1 ? 'EyeIcon' : 'EyeOffIcon'"
                              :svgClasses="['text-white', 'h-5 w-5 mt-2']"
                            ></feather-icon>
                          </span>
                        </div>
                      </template>
                    </vx-input-group>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>

                <div class="vx-col w-full mt-2">
                  <p>{{ $t('barman.EnterValidEmail') }}</p>
                </div>
                <div class="vx-col w-full text-right">
                  <vs-button
                    type="filled"
                    color="primary"
                    @click="handleSubmit"
                    class="btn-primary btn--xlarge-auto font-weight-bold"
                  >
                    {{ $t('Crear') }}
                  </vs-button>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-5/12">
            <vx-card class="mb-base" title="Avatar">
              <ImageDropzone ref="images"></ImageDropzone>
            </vx-card>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { generateRandomPassword } from '../../utils/helpers';
import { mapActions, mapGetters } from 'vuex';
import ImageDropzone from '@/components/ImageDropzone';

export default {
  components: {
    ImageDropzone,
  },
  props: ['dialog'],
  data () {
    return {
      email: '',
      avatar: '',
      name: '',
      surname: '',
      phone: '',
      job: '',
      password: '',
      tables: [],
      restaurants: [],
      show1: false,
    };
  },
  computed: {
    ...mapGetters({
      currentRestaurant: 'getCurrentRestaurant',
      language: 'getCurrentLanguage',
      languages: 'getLanguages',
      itemsTables: 'getSelectTables',
      itemsRestaurants: 'getRestaurantsUser',
    }),
    checkRestaurants () {
      const arrayChecks = [];
      const tables = this.tables;
      this.itemsTables.forEach(function (restaurant, index) {
        let complete = true;
        restaurant.group.forEach(function (table) {
          if (!tables.includes(table.value)) {
            complete = false;
          }
        });
        arrayChecks[index] = complete;
      });
      return arrayChecks;
    },
  },
  created () {
    this.restaurants.push(this.currentRestaurant);
    this.restaurantsChanged();
  },
  methods: {
    generateRandomPassword,
    ...mapActions({
      createBarman: 'createBarman',
      getListTables: 'getListTables',
    }),
    handleSubmit () {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            Object.keys(errors).forEach((key) => {
              const error = errors[key];
              if (error.length) {
                error.forEach(function (text) {
                  textAux += `<p>${text}</p>`;
                });
              }
            });
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();

        this.createBarman({
          barman: formData,
          language: this.language,
        });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    createFormData () {
      // const data = new FormData();
      const data = this.$refs.images.getFormData();
      data.append('name', this.name);
      data.append('surname', this.surname);
      data.append('email', this.email);
      data.append('phone', this.phone);
      data.append('job', this.job);
      data.append('password', this.password);
      data.append('restaurant_id', this.currentRestaurant);

      const tables = this.tables;
      let i = 0;

      this.itemsTables.forEach(function (restaurant) {
        restaurant.group.forEach(function (table) {
          if (tables.includes(table.value)) {
            data.append(`tables[${i}]`, table.value);
            i++;
          }
        });
      });

      const restaurants = this.restaurants;
      i = 0;
      restaurants.forEach(function (restaurant) {
        data.append(`restaurants[${i}]`, restaurant);
        i++;
      });

      return data;
    },
    restaurantsChanged () {
      if (this.restaurants.length) {
        this.getListTables({ restaurants: this.restaurants });
      } else {
        this.$store.commit('setSelectTables', {});
        this.tables = [];
      }
    },
    selectRestaurant (indexRestaurant) {
      const tables = this.tables;
      const valueCheckbox = this.checkRestaurants[indexRestaurant];
      this.itemsTables.forEach(function (restaurant, index) {
        if (index === indexRestaurant) {
          restaurant.group.forEach(function (table) {
            if (valueCheckbox) {
              if (!tables.includes(table.value)) {
                tables.push(table.value);
              }
            } else {
              const index = tables.indexOf(table.value);
              if (index > -1) {
                tables.splice(index, 1);
              }
            }
          });
        }
      });
    },
  },
};
</script>
